export default __webpack_public_path__ + "static/india-d775060935fcc168d05b6e9ef0d6910d.svg";